module.exports = __webpack_public_path__ + "img/AC charging 1.15ddc164.svg";